// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #6366f1;
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --bg-gradient: linear-gradient(180deg, #f3f4f6 0%, #ffffff 100%);
}

.membership-page-new {
    min-height: 100vh;
    background: #f8f9fc;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    color: var(--text-primary);
    overflow-x: hidden;
    position: relative;
    padding-bottom: 20px;
}

.page-header-clean {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    background: rgba(255, 255, 255, 0.85);
    backdrop-filter: blur(12px);
    position: sticky;
    top: 0;
    z-index: 100;
    transition: background 0.3s;
}

.page-header-clean.transparent {
    background: rgba(255,255,255,0.5);
}

.page-header-clean h1 {
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    flex: 1 1;
    text-align: center;
    margin-right: 24px;
    color: #1f2937;
}

.back-icon {
    background: none;
    border: none;
    color: #1f2937;
    padding: 8px;
    margin-left: -8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 50%;
    transition: background 0.2s;
}

.back-icon:hover {
    background: rgba(0,0,0,0.05);
}

.content-scroll {
    padding: 0 20px 100px;
    max-width: 600px;
    margin: 0 auto;
}

.page-intro {
    margin: 30px 0 40px;
    text-align: center;
}

.intro-badge {
    display: inline-block;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #6366f1;
    background: rgba(99, 102, 241, 0.1);
    padding: 6px 12px;
    border-radius: 20px;
    margin-bottom: 16px;
}

.page-intro h2 {
    font-size: 28px;
    font-weight: 800;
    margin: 0 0 10px;
    color: #111827;
    letter-spacing: -0.5px;
}

.page-intro p {
    color: #6b7280;
    font-size: 15px;
    margin: 0;
    font-weight: 400;
}

/* Card Grid */
.packages-grid {
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
}

.package-card-new {
    position: relative;
    border-radius: 24px;
    background: #fff;
    padding: 28px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.02), 0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border: 2px solid transparent;
    cursor: pointer;
    overflow: hidden;
}

.package-card-new:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 40px rgba(0,0,0,0.08); /* 更柔和的阴影 */
}

.package-card-new.selected {
    background: #fff;
    border-color: transparent;
    box-shadow: 0 0 0 2px #fff, 0 0 0 5px var(--primary-shadow-color, rgba(99, 102, 241, 0.3)); /* 多重阴影模拟高亮 */
    transform: scale(1.02);
}

.card-bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 140px;
    opacity: 0.12;
    z-index: 0;
    mask-image: linear-gradient(to bottom, black 50%, transparent 100%);
}

.card-tag {
    position: absolute;
    top: 0;
    right: 0;
    padding: 8px 16px;
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    border-bottom-left-radius: 16px;
    z-index: 1;
    box-shadow: -2px 2px 8px rgba(0,0,0,0.1);
}

.card-header {
    position: relative;
    z-index: 1;
    text-align: center;
    margin-bottom: 24px;
}

.card-header h3 {
    font-size: 18px;
    margin: 0 0 16px;
    font-weight: 800;
    letter-spacing: -0.5px;
}

.price-block {
    display: flex;
    align-items: baseline;
    justify-content: center;
    color: #111827;
}

.price-block .currency {
    font-size: 22px;
    font-weight: 600;
    margin-right: 2px;
}

.price-block .amount {
    font-size: 48px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -2px;
}

.price-block .period {
    font-size: 15px;
    color: #9ca3af;
    margin-left: 6px;
    font-weight: 500;
}

.original-price {
    text-decoration: line-through;
    color: #d1d5db;
    font-size: 14px;
    margin-top: 6px;
    font-weight: 500;
}

.card-divider {
    height: 1px;
    background: #f3f4f6;
    margin: 0 20px 24px;
    position: relative;
    z-index: 1;
}

.card-benefits {
    position: relative;
    z-index: 1;
    padding: 0 10px;
}

.benefit-row {
    display: flex;
    align-items: flex-start;
    margin-bottom: 14px;
    font-size: 15px;
    color: #4b5563;
    line-height: 1.5;
}

.benefit-row.primary {
    color: #111827;
    font-weight: 600;
}

.icon-circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    color: #fff;
    font-size: 12px;
    margin-right: 12px;
    flex-shrink: 0;
    margin-top: 2px;
}

.icon-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    margin-right: 19px; /* Align with circle icon center */
    margin-left: 7px;
    margin-top: 8px;
    opacity: 0.5;
    flex-shrink: 0;
}

.card-action {
    margin-top: 28px;
    text-align: center;
    height: 24px;
    z-index: 1;
    position: relative;
    display: flex;
    justify-content: center;
}

.selected-mark {
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.check-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    background: currentColor;
    color: #fff;
    border-radius: 50%;
    font-size: 10px;
}

.click-tip {
    color: #9ca3af;
    font-size: 13px;
    font-weight: 500;
    opacity: 0;
    transform: translateY(5px);
    transition: all 0.3s;
}

.package-card-new:hover .click-tip {
    opacity: 1;
    transform: translateY(0);
}

/* Bottom Bar */
.fixed-bottom-bar {
    position: fixed;
    bottom: 30px;
    left: 20px;
    right: 20px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 20px;
    padding: 16px 24px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1000;
    max-width: 500px;
    margin: 0 auto;
    animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    border: 1px solid rgba(255,255,255,0.5);
}

.bar-info {
    display: flex;
    align-items: center;
}

.bar-label {
    font-size: 13px;
    color: #6b7280;
    margin-right: 8px;
}

.bar-details {
    display: flex;
    flex-direction: column;
}

.bar-name {
    font-weight: 700;
    font-size: 14px;
    color: #111827;
    line-height: 1.2;
}

.bar-price {
    color: #ef4444; /* Price is always red/prominent */
    font-weight: 800;
    font-size: 18px;
    line-height: 1.2;
}

.bar-price small {
    font-size: 12px;
    font-weight: 500;
    opacity: 0.8;
}

.btn-confirm {
    color: #fff;
    border: none;
    padding: 12px 28px;
    border-radius: 14px;
    font-weight: 700;
    font-size: 15px;
    cursor: pointer;
    box-shadow: 0 4px 15px rgba(0,0,0,0.2);
    transition: transform 0.2s;
}

.btn-confirm:hover {
    transform: scale(1.05);
}

.form-wrapper {
    margin-top: 20px;
}

.package-summary {
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    color: #333;
    position: relative;
    overflow: hidden;
}

.package-summary::after {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255,255,255,0.4);
    z-index: 0;
}

.package-summary > * {
    position: relative;
    z-index: 1;
}

.summary-left h4 {
    margin: 0 0 4px;
    font-size: 16px;
}

.summary-left p {
    margin: 0;
    font-size: 12px;
    opacity: 0.8;
}

.summary-right .price {
    font-size: 24px;
    font-weight: 700;
}

.summary-right small {
    font-size: 12px;
}

.btn-change-text {
    background: rgba(255,255,255,0.5);
    border: 1px solid rgba(0,0,0,0.1);
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    cursor: pointer;
    margin-left: 12px;
}

/* Stepper */
.step-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    padding: 0 40px;
}

.step-dot {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #e5e7eb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    z-index: 2;
}

.step-dot.active {
    background: var(--primary-color);
    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.2);
}

.step-line {
    flex: 1 1;
    height: 2px;
    background: #e5e7eb;
    margin: 0 -4px;
    z-index: 1;
}

.step-labels {
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    margin-bottom: 30px;
    font-size: 12px;
    color: var(--text-secondary);
}

.form-card {
    background: #fff;
    border-radius: 24px;
    padding: 30px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.03);
}

.form-title {
    margin: 0 0 24px;
    font-size: 18px;
    text-align: center;
}

.clean-form .input-group {
    margin-bottom: 20px;
}

.clean-form label {
    display: block;
    font-size: 13px;
    color: var(--text-secondary);
    margin-bottom: 8px;
    font-weight: 500;
}

.clean-form input,
.clean-form select {
    width: 100%;
    padding: 14px;
    border: 2px solid #f3f4f6;
    border-radius: 12px;
    font-size: 16px;
    background: #f9fafb;
    transition: all 0.2s;
    box-sizing: border-box;
    appearance: none;
}

.clean-form input:focus,
.clean-form select:focus {
    border-color: var(--primary-color);
    background: #fff;
    outline: none;
}

.select-wrapper {
    position: relative;
}

.select-wrapper::after {
    content: "▼";
    font-size: 10px;
    color: #9ca3af;
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
}

.btn-next {
    width: 100%;
    padding: 16px;
    background: var(--primary-color);
    color: #fff;
    border: none;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);
    transition: transform 0.1s;
}

.btn-next:active {
    transform: scale(0.98);
}

.btn-row {
    display: flex;
    gap: 12px;
}

.btn-outline {
    width: 30%;
    padding: 16px;
    background: #fff;
    border: 2px solid #e5e7eb;
    color: var(--text-secondary);
    border-radius: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 10px;
}

.agreement-check {
    margin-top: 10px;
    margin-bottom: 20px;
    text-align: center;
}


/* Modal Styles */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    backdrop-filter: blur(4px);
    animation: fadeIn 0.3s;
}

.modal-content {
    background: #fff;
    width: 90%;
    max-width: 500px;
    max-height: 80vh;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 40px rgba(0,0,0,0.2);
    animation: scaleIn 0.3s;
}

.modal-header {
    padding: 16px 20px;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.modal-header h3 { margin: 0; font-size: 16px; color: #333; font-weight: 600; }
.modal-close { background: none; border: none; font-size: 24px; cursor: pointer; padding: 0; color: #999; line-height: 1; }

.modal-body {
    padding: 20px;
    overflow-y: auto;
    font-size: 13px;
    line-height: 1.8;
    color: #666;
    background: #fcfcfc;
}

.modal-footer {
    padding: 16px 20px;
    border-top: 1px solid #f0f0f0;
    background: #fff;
    border-radius: 0 0 16px 16px;
}

@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
@keyframes scaleIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }

.link-text { color: #1976d2; cursor: pointer; font-weight: 500; }
.link-text:hover { text-decoration: underline; }

/* 移动端适配 */
@media (max-width: 600px) {
    .packages-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/MembershipPackage.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yBAAyB;EACzB,gEAAgE;AAClE;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gGAAgG;IAChG,0BAA0B;IAC1B,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,2BAA2B;IAC3B,gBAAgB;IAChB,MAAM;IACN,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAO;IACP,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,mCAAmC;IACnC,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,SAAS;IACT,2DAA2D;AAC/D;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,oEAAoE;IACpE,iDAAiD;IACjD,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC,EAAE,WAAW;AACzD;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,0FAA0F,EAAE,aAAa;IACzG,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,aAAa;IACb,UAAU;IACV,mEAAmE;AACvE;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,kBAAkB,EAAE,kCAAkC;IACtD,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,0BAA0B;IAC1B,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA,eAAe;AACf;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,WAAW;IACX,qCAAqC;IACrC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,+DAA+D;IAC/D,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc,EAAE,kCAAkC;IAClD,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,sCAAsC;IACtC,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,iCAAiC;IACjC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,6CAA6C;AACjD;;AAEA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;IAEI,kCAAkC;IAClC,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,+CAA+C;IAC/C,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,4BAA4B;IAC5B,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA,iBAAiB;AACjB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,0BAA0B;IAC1B,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA,mBAAmB,SAAS,EAAE,eAAe,EAAE,WAAW,EAAE,gBAAgB,EAAE;AAC9E,eAAe,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,UAAU,EAAE,WAAW,EAAE,cAAc,EAAE;;AAE1H;IACI,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA,oBAAoB,OAAO,UAAU,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;AAC5D,qBAAqB,OAAO,sBAAsB,EAAE,UAAU,EAAE,EAAE,KAAK,mBAAmB,EAAE,UAAU,EAAE,EAAE;;AAE1G,aAAa,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAChE,mBAAmB,0BAA0B,EAAE;;AAE/C,UAAU;AACV;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[":root {\r\n  --primary-color: #6366f1;\r\n  --text-primary: #1f2937;\r\n  --text-secondary: #6b7280;\r\n  --bg-gradient: linear-gradient(180deg, #f3f4f6 0%, #ffffff 100%);\r\n}\r\n\r\n.membership-page-new {\r\n    min-height: 100vh;\r\n    background: #f8f9fc;\r\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n    color: var(--text-primary);\r\n    overflow-x: hidden;\r\n    position: relative;\r\n    padding-bottom: 20px;\r\n}\r\n\r\n.page-header-clean {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 16px 20px;\r\n    background: rgba(255, 255, 255, 0.85);\r\n    backdrop-filter: blur(12px);\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 100;\r\n    transition: background 0.3s;\r\n}\r\n\r\n.page-header-clean.transparent {\r\n    background: rgba(255,255,255,0.5);\r\n}\r\n\r\n.page-header-clean h1 {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    margin: 0;\r\n    flex: 1;\r\n    text-align: center;\r\n    margin-right: 24px;\r\n    color: #1f2937;\r\n}\r\n\r\n.back-icon {\r\n    background: none;\r\n    border: none;\r\n    color: #1f2937;\r\n    padding: 8px;\r\n    margin-left: -8px;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    border-radius: 50%;\r\n    transition: background 0.2s;\r\n}\r\n\r\n.back-icon:hover {\r\n    background: rgba(0,0,0,0.05);\r\n}\r\n\r\n.content-scroll {\r\n    padding: 0 20px 100px;\r\n    max-width: 600px;\r\n    margin: 0 auto;\r\n}\r\n\r\n.page-intro {\r\n    margin: 30px 0 40px;\r\n    text-align: center;\r\n}\r\n\r\n.intro-badge {\r\n    display: inline-block;\r\n    font-size: 11px;\r\n    font-weight: 700;\r\n    letter-spacing: 1px;\r\n    text-transform: uppercase;\r\n    color: #6366f1;\r\n    background: rgba(99, 102, 241, 0.1);\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    margin-bottom: 16px;\r\n}\r\n\r\n.page-intro h2 {\r\n    font-size: 28px;\r\n    font-weight: 800;\r\n    margin: 0 0 10px;\r\n    color: #111827;\r\n    letter-spacing: -0.5px;\r\n}\r\n\r\n.page-intro p {\r\n    color: #6b7280;\r\n    font-size: 15px;\r\n    margin: 0;\r\n    font-weight: 400;\r\n}\r\n\r\n/* Card Grid */\r\n.packages-grid {\r\n    display: grid;\r\n    gap: 24px;\r\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n}\r\n\r\n.package-card-new {\r\n    position: relative;\r\n    border-radius: 24px;\r\n    background: #fff;\r\n    padding: 28px;\r\n    box-shadow: 0 4px 6px rgba(0,0,0,0.02), 0 12px 24px rgba(0,0,0,0.04);\r\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n    border: 2px solid transparent;\r\n    cursor: pointer;\r\n    overflow: hidden;\r\n}\r\n\r\n.package-card-new:hover {\r\n    transform: translateY(-8px);\r\n    box-shadow: 0 20px 40px rgba(0,0,0,0.08); /* 更柔和的阴影 */\r\n}\r\n\r\n.package-card-new.selected {\r\n    background: #fff;\r\n    border-color: transparent;\r\n    box-shadow: 0 0 0 2px #fff, 0 0 0 5px var(--primary-shadow-color, rgba(99, 102, 241, 0.3)); /* 多重阴影模拟高亮 */\r\n    transform: scale(1.02);\r\n}\r\n\r\n.card-bg {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    height: 140px;\r\n    opacity: 0.12;\r\n    z-index: 0;\r\n    mask-image: linear-gradient(to bottom, black 50%, transparent 100%);\r\n}\r\n\r\n.card-tag {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    padding: 8px 16px;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    font-weight: 700;\r\n    border-bottom-left-radius: 16px;\r\n    z-index: 1;\r\n    box-shadow: -2px 2px 8px rgba(0,0,0,0.1);\r\n}\r\n\r\n.card-header {\r\n    position: relative;\r\n    z-index: 1;\r\n    text-align: center;\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.card-header h3 {\r\n    font-size: 18px;\r\n    margin: 0 0 16px;\r\n    font-weight: 800;\r\n    letter-spacing: -0.5px;\r\n}\r\n\r\n.price-block {\r\n    display: flex;\r\n    align-items: baseline;\r\n    justify-content: center;\r\n    color: #111827;\r\n}\r\n\r\n.price-block .currency {\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n    margin-right: 2px;\r\n}\r\n\r\n.price-block .amount {\r\n    font-size: 48px;\r\n    font-weight: 800;\r\n    line-height: 1;\r\n    letter-spacing: -2px;\r\n}\r\n\r\n.price-block .period {\r\n    font-size: 15px;\r\n    color: #9ca3af;\r\n    margin-left: 6px;\r\n    font-weight: 500;\r\n}\r\n\r\n.original-price {\r\n    text-decoration: line-through;\r\n    color: #d1d5db;\r\n    font-size: 14px;\r\n    margin-top: 6px;\r\n    font-weight: 500;\r\n}\r\n\r\n.card-divider {\r\n    height: 1px;\r\n    background: #f3f4f6;\r\n    margin: 0 20px 24px;\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.card-benefits {\r\n    position: relative;\r\n    z-index: 1;\r\n    padding: 0 10px;\r\n}\r\n\r\n.benefit-row {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    margin-bottom: 14px;\r\n    font-size: 15px;\r\n    color: #4b5563;\r\n    line-height: 1.5;\r\n}\r\n\r\n.benefit-row.primary {\r\n    color: #111827;\r\n    font-weight: 600;\r\n}\r\n\r\n.icon-circle {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 20px;\r\n    height: 20px;\r\n    border-radius: 50%;\r\n    color: #fff;\r\n    font-size: 12px;\r\n    margin-right: 12px;\r\n    flex-shrink: 0;\r\n    margin-top: 2px;\r\n}\r\n\r\n.icon-dot {\r\n    width: 6px;\r\n    height: 6px;\r\n    border-radius: 50%;\r\n    margin-right: 19px; /* Align with circle icon center */\r\n    margin-left: 7px;\r\n    margin-top: 8px;\r\n    opacity: 0.5;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.card-action {\r\n    margin-top: 28px;\r\n    text-align: center;\r\n    height: 24px;\r\n    z-index: 1;\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.selected-mark {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.check-icon {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 18px;\r\n    height: 18px;\r\n    background: currentColor;\r\n    color: #fff;\r\n    border-radius: 50%;\r\n    font-size: 10px;\r\n}\r\n\r\n.click-tip {\r\n    color: #9ca3af;\r\n    font-size: 13px;\r\n    font-weight: 500;\r\n    opacity: 0;\r\n    transform: translateY(5px);\r\n    transition: all 0.3s;\r\n}\r\n\r\n.package-card-new:hover .click-tip {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n}\r\n\r\n/* Bottom Bar */\r\n.fixed-bottom-bar {\r\n    position: fixed;\r\n    bottom: 30px;\r\n    left: 20px;\r\n    right: 20px;\r\n    background: rgba(255, 255, 255, 0.95);\r\n    backdrop-filter: blur(20px);\r\n    border-radius: 20px;\r\n    padding: 16px 24px;\r\n    box-shadow: 0 10px 40px rgba(0,0,0,0.15);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    z-index: 1000;\r\n    max-width: 500px;\r\n    margin: 0 auto;\r\n    animation: slideUp 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\r\n    border: 1px solid rgba(255,255,255,0.5);\r\n}\r\n\r\n.bar-info {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.bar-label {\r\n    font-size: 13px;\r\n    color: #6b7280;\r\n    margin-right: 8px;\r\n}\r\n\r\n.bar-details {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.bar-name {\r\n    font-weight: 700;\r\n    font-size: 14px;\r\n    color: #111827;\r\n    line-height: 1.2;\r\n}\r\n\r\n.bar-price {\r\n    color: #ef4444; /* Price is always red/prominent */\r\n    font-weight: 800;\r\n    font-size: 18px;\r\n    line-height: 1.2;\r\n}\r\n\r\n.bar-price small {\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    opacity: 0.8;\r\n}\r\n\r\n.btn-confirm {\r\n    color: #fff;\r\n    border: none;\r\n    padding: 12px 28px;\r\n    border-radius: 14px;\r\n    font-weight: 700;\r\n    font-size: 15px;\r\n    cursor: pointer;\r\n    box-shadow: 0 4px 15px rgba(0,0,0,0.2);\r\n    transition: transform 0.2s;\r\n}\r\n\r\n.btn-confirm:hover {\r\n    transform: scale(1.05);\r\n}\r\n\r\n.form-wrapper {\r\n    margin-top: 20px;\r\n}\r\n\r\n.package-summary {\r\n    border-radius: 16px;\r\n    padding: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    margin-bottom: 30px;\r\n    color: #333;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.package-summary::after {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    background: rgba(255,255,255,0.4);\r\n    z-index: 0;\r\n}\r\n\r\n.package-summary > * {\r\n    position: relative;\r\n    z-index: 1;\r\n}\r\n\r\n.summary-left h4 {\r\n    margin: 0 0 4px;\r\n    font-size: 16px;\r\n}\r\n\r\n.summary-left p {\r\n    margin: 0;\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n}\r\n\r\n.summary-right .price {\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n}\r\n\r\n.summary-right small {\r\n    font-size: 12px;\r\n}\r\n\r\n.btn-change-text {\r\n    background: rgba(255,255,255,0.5);\r\n    border: 1px solid rgba(0,0,0,0.1);\r\n    padding: 6px 12px;\r\n    border-radius: 20px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    margin-left: 12px;\r\n}\r\n\r\n/* Stepper */\r\n.step-indicator {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 8px;\r\n    padding: 0 40px;\r\n}\r\n\r\n.step-dot {\r\n    width: 28px;\r\n    height: 28px;\r\n    border-radius: 50%;\r\n    background: #e5e7eb;\r\n    color: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 14px;\r\n    font-weight: 700;\r\n    z-index: 2;\r\n}\r\n\r\n.step-dot.active {\r\n    background: var(--primary-color);\r\n    box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.2);\r\n}\r\n\r\n.step-line {\r\n    flex: 1;\r\n    height: 2px;\r\n    background: #e5e7eb;\r\n    margin: 0 -4px;\r\n    z-index: 1;\r\n}\r\n\r\n.step-labels {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    padding: 0 20px;\r\n    margin-bottom: 30px;\r\n    font-size: 12px;\r\n    color: var(--text-secondary);\r\n}\r\n\r\n.form-card {\r\n    background: #fff;\r\n    border-radius: 24px;\r\n    padding: 30px;\r\n    box-shadow: 0 4px 20px rgba(0,0,0,0.03);\r\n}\r\n\r\n.form-title {\r\n    margin: 0 0 24px;\r\n    font-size: 18px;\r\n    text-align: center;\r\n}\r\n\r\n.clean-form .input-group {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.clean-form label {\r\n    display: block;\r\n    font-size: 13px;\r\n    color: var(--text-secondary);\r\n    margin-bottom: 8px;\r\n    font-weight: 500;\r\n}\r\n\r\n.clean-form input,\r\n.clean-form select {\r\n    width: 100%;\r\n    padding: 14px;\r\n    border: 2px solid #f3f4f6;\r\n    border-radius: 12px;\r\n    font-size: 16px;\r\n    background: #f9fafb;\r\n    transition: all 0.2s;\r\n    box-sizing: border-box;\r\n    appearance: none;\r\n}\r\n\r\n.clean-form input:focus,\r\n.clean-form select:focus {\r\n    border-color: var(--primary-color);\r\n    background: #fff;\r\n    outline: none;\r\n}\r\n\r\n.select-wrapper {\r\n    position: relative;\r\n}\r\n\r\n.select-wrapper::after {\r\n    content: \"▼\";\r\n    font-size: 10px;\r\n    color: #9ca3af;\r\n    position: absolute;\r\n    right: 16px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    pointer-events: none;\r\n}\r\n\r\n.btn-next {\r\n    width: 100%;\r\n    padding: 16px;\r\n    background: var(--primary-color);\r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.25);\r\n    transition: transform 0.1s;\r\n}\r\n\r\n.btn-next:active {\r\n    transform: scale(0.98);\r\n}\r\n\r\n.btn-row {\r\n    display: flex;\r\n    gap: 12px;\r\n}\r\n\r\n.btn-outline {\r\n    width: 30%;\r\n    padding: 16px;\r\n    background: #fff;\r\n    border: 2px solid #e5e7eb;\r\n    color: var(--text-secondary);\r\n    border-radius: 12px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n}\r\n\r\n.agreement-check {\r\n    margin-top: 10px;\r\n    margin-bottom: 20px;\r\n    text-align: center;\r\n}\r\n\r\n\r\n/* Modal Styles */\r\n.modal-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(0,0,0,0.5);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    backdrop-filter: blur(4px);\r\n    animation: fadeIn 0.3s;\r\n}\r\n\r\n.modal-content {\r\n    background: #fff;\r\n    width: 90%;\r\n    max-width: 500px;\r\n    max-height: 80vh;\r\n    border-radius: 16px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 10px 40px rgba(0,0,0,0.2);\r\n    animation: scaleIn 0.3s;\r\n}\r\n\r\n.modal-header {\r\n    padding: 16px 20px;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n.modal-header h3 { margin: 0; font-size: 16px; color: #333; font-weight: 600; }\r\n.modal-close { background: none; border: none; font-size: 24px; cursor: pointer; padding: 0; color: #999; line-height: 1; }\r\n\r\n.modal-body {\r\n    padding: 20px;\r\n    overflow-y: auto;\r\n    font-size: 13px;\r\n    line-height: 1.8;\r\n    color: #666;\r\n    background: #fcfcfc;\r\n}\r\n\r\n.modal-footer {\r\n    padding: 16px 20px;\r\n    border-top: 1px solid #f0f0f0;\r\n    background: #fff;\r\n    border-radius: 0 0 16px 16px;\r\n}\r\n\r\n@keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }\r\n@keyframes scaleIn { from { transform: scale(0.95); opacity: 0; } to { transform: scale(1); opacity: 1; } }\r\n\r\n.link-text { color: #1976d2; cursor: pointer; font-weight: 500; }\r\n.link-text:hover { text-decoration: underline; }\r\n\r\n/* 移动端适配 */\r\n@media (max-width: 600px) {\r\n    .packages-grid {\r\n        grid-template-columns: 1fr;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
